import React from 'react';
import { Button, Typography, Dialog } from '../../../../UIKit';
import { Close } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { PRIMARY_BLUE } from '../../../../Constants/Colors.constants';
import { Present } from '../../../../Components/Icons/Present';
import { makeStyles } from '~/UIKit/Style';

export interface CloseCheckInDialogProps {
  onConfirmCloseCheckIn: () => void;
  onClose: () => void;
  bookingInformation: {
    present: number;
    none: number;
    booked: number;
    total: number;
  };
}

const useStyles = makeStyles({
  root: {
    minHeight: 637,
    minWidth: 345,
    maxWidth: 345,
    padding: '25px 30px',
    borderRadius: 0,
  },
  title: {
    fontWeight: 'bold',
  },
  bookingInfo: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    '& > svg': {
      fontSize: 16,
      marginRight: 5,
    },
    marginTop: 28,
    marginBottom: 30,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  closeButton: {
    fontSize: 12,
    top: -15,
    right: '-40%',
    position: 'relative',
    color: PRIMARY_BLUE,
  },
  confirmButton: {
    marginTop: 30,
    minWidth: 245,
  },
  cancelButton: {
    color: PRIMARY_BLUE,
    marginTop: 30,
  },
});

export default function CloseCheckInDialog({
  onConfirmCloseCheckIn,
  bookingInformation,
  onClose,
}: CloseCheckInDialogProps) {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { present, total, booked } = bookingInformation;
  return (
    <Dialog
      classes={{
        paper: classes.root,
      }}
      data-testid="CloseCheckInDialog"
      onClose={onClose}
      open
    >
      <div className={classes.content}>
        <Button
          className={classes.closeButton}
          data-testid="CloseCheckInDialogCloseX"
          endIcon={<Close />}
          onClick={onClose}
        >
          {t('app.close')}
        </Button>
        <Typography className={classes.title} variant="h5">
          {t('app.checkin.closeDialog.title')}
        </Typography>
        <Typography className={classes.bookingInfo}>
          <Present />
          <b>{present}</b>
          {` / ${booked} (${total})`}
        </Typography>
        <Typography className={classes.content}>
          {t('app.checkin.closeDialog.description', {
            total: bookingInformation.booked,
            none: bookingInformation.none,
          })}
        </Typography>
        <Button
          className={classes.confirmButton}
          color="primary"
          data-testid="CloseCheckInDialogConfirmButton"
          onClick={onConfirmCloseCheckIn}
          variant="contained"
        >
          {t('app.checkin.confirmClose')}
        </Button>
        <Button
          className={classes.cancelButton}
          data-testid="CloseCheckInDialogCloseButton"
          onClick={onClose}
        >
          {t('app.cancel')}
        </Button>
      </div>
    </Dialog>
  );
}
